module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICAgIDxwYXRoIGZpbGw9IiM0RkE0NDQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzLjE4MyA1LjUwNmExLjEzOSAxLjEzOSAwIDAgMSAxLjY0Ny4xODUgMS4yNTkgMS4yNTkgMCAwIDEtLjIwNCAxLjcxNmwtNS41NDQgNC41ODJhMS4xMzkgMS4xMzkgMCAwIDEtMS40Ny4wMDJMMi4yODUgNy40OTZjLS41LS40MjItLjU3LTEuMTktLjE1Ny0xLjcxNS40MTQtLjUyNiAxLjE1My0uNjExIDEuNjUzLS4xOWw0LjYwMyAzLjg4MyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/down.svg
// module id = 424
// module chunks = 0